<template>
<div>
    <v-app-bar color="primary" dark dense fixed app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Image Maker</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click.prevent="invertColors()"><v-icon>invert_colors</v-icon></v-btn>

      <v-menu bottom left v-if="isAuthenticated">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar size="36px">
              <v-img v-if="profile" :src="profile.picture"></v-img>
            </v-avatar>
          </v-btn>
        </template>

        <v-layout row wrap>
          <v-flex xs12>
            <v-card max-width="344" class="mx-auto">
              <v-list-item>
                <v-list-item-avatar color="grey"><v-img :src="profile.picture" contain></v-img></v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline">{{ profile.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ profile.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider light></v-divider>

              <v-card-actions>
                <v-btn text @click.prevent="$router.push('/profile');"><v-icon>person</v-icon>Profile</v-btn>
                <v-spacer></v-spacer>
                <v-btn text @click.prevent="logout()"><v-icon>power_settings_new</v-icon>Logout</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-menu>

      <v-btn text @click.prevent="login()" v-else>Login</v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      clipped
      fixed
      app
      v-if="isAuthenticated || !production"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">Image Maker</v-list-item-title>
          <v-list-item-subtitle>{{ version }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item v-for="item in items" :key="item.title" link @click="goTo(item)">
          <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>{{ item.title }}</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense nav v-if="aaaaccess(user)">
        <v-list-item v-for="item in aaaitems" :key="item.title" link @click="goTo(item)">
          <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>{{ item.title }}</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

  </div>
</template>

<script>
import config from '../../config/config.json';
import { mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'

export default {
  mixins: [libvue],
  data () {
    return {
      production: process.env.NODE_ENV == 'production' ? true : false,
      isAuthenticated: false,
      profile: {},
      drawer: null,
      items: [
        { title: 'Home', icon: 'dashboard', value: 'home' },
        { title: 'Images', icon: 'album', value: 'images' },
       // { title: 'Docs', icon: 'help', value: 'docs-page' }
      ],
      aaaitems: [
        { title: 'Credentials', icon: 'vpn_key', value: 'image-creds' },
        { title: 'Devices', icon: 'devices', value: 'devices' },
        { title: 'Templates', icon: 'reorder', value: 'templates' },
        { title: 'Upstream', icon: 'unarchive', value: 'upstream' }
      ],
      right: null,
      version: config.version
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    if (this.$cookie.get("dark") == "true") {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
  },
  methods: {
    goTo(item) {
      this.$router.push({ name: item.value });
    },
    login() {
      this.$auth.login();
    },
    logout() {
      this.$auth.logOut();
    },
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn;
      this.profile = data.profile;
    },
    invertColors() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.$cookie.set("dark", this.$vuetify.theme.dark, { expires: '1Y' });
    },
  }
}
</script>
